import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import {InputMask} from "primereact/inputmask";
import moment from "moment";
import {Calendar} from "primereact/calendar";

const EmploymentFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    employee: window.App.urlVars().employeeId,
    start_date: new Date(),
    remote_work: 'full',
  });
  const [types, setTypes] = useState([]);
  const [employees, setEmployees] = useState([]);

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if ((window.App.urlVars().employmentId) || (entity === 'employment' && id)) {
      apiCall('patch', '/api/v2/employment/' + (window.App.urlVars().employmentId ?? id), data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderEmploymentList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/employment', data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderEmploymentList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/hr/employment/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    apiCall('get', '/api/v2/employment-type')
      .then(response => {
        setTypes(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    let _emloyeeQuery = {
      rows: 9999
    }
    let emloyeeQuery = window.App.transformQueryParams(_emloyeeQuery)
    apiCall('get', '/api/v2/employee' + emloyeeQuery)
      .then(response => {
        setEmployees(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if ((!window.App.urlVars().create && window.App.urlVars().employmentId) || (entity === 'employment' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/employment/' + (window.App.urlVars().employmentId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  return (
    <div className={"employment-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="remote_work"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldRemoteWork')}</label>
                  <span className="p-d-block">
                    <Dropdown options={window.App.sortDropdownOptions([
                                {
                                  code: 'full',
                                  name: 'Teljes távmunka'
                                },
                                {
                                  code: 'partly',
                                  name: 'Részben távmunka (hibrid)'
                                },
                                {
                                  code: 'none',
                                  name: 'Helyszíni/iroda munka'
                                },
                              ], "name")}
                              id={"remote_work"}
                              optionValue={"code"}
                              optionLabel={"name"}
                              emptyMessage={t('noWorkTypeYet')}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  remote_work: e.value
                                })
                              }}
                              value={formData.remote_work?.id || formData.remote_work}
                    />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="employee" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="employment_type"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('employee')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions(employees, "name")}
                               filter
                               id={"employee"}
                               disabled={window.App.urlVars().employeeId || id}
                               optionValue={"id"}
                               optionLabel={"name"}
                               emptyMessage={t('noEmployeeYet')}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   employee: e.value
                                 })
                               }}
                               value={Number(window.App.urlVars().employeeId) || formData.employee?.id || formData.employee}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="employment_type" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="employment_type"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldType')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions(types, "name")}
                               id={"employment_type"}
                               optionValue={"id"}
                               optionLabel={"name"}
                               emptyMessage={t('noEmployeePosition')}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   employment_type: e.value
                                 })
                               }}
                               value={formData?.employment_type?.id || formData.employment_type}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className="p-col-12 p-lg-6">
              <Field name="start_date" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="start_date"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldStart')}</label>
                  <span className="p-d-block">
                    <div className="p-inputgroup calendar-icon-only">
                      <InputMask id={"start_date"}
                                 mask={"9999-99-99"}
                                 placeholder={t('datePlaceholder')}
                                 value={moment.utc(formData.start_date).local().format('YYYY-MM-DD')}
                                 onChange={(e) => {
                                   if (e.value.indexOf("_") === -1) {
                                     if (e.value === '') {
                                       e.value = null
                                     }
                                     setFormData({
                                       ...formData,
                                       start_date: moment.utc(e.value).local().format('YYYY-MM-DD')
                                     })
                                   }
                                 }}
                      />
                      <Calendar value={formData.start_date}
                                locale="hu"
                                dateFormat={'yy-mm-dd'}
                                showIcon
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    start_date: moment.utc(e.value).local().format('YYYY-MM-DD')
                                  })
                                }}/>
                    </div>
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className="p-col-12 p-lg-6">
              <Field name="end_of_probationary" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="end_of_probationary"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldEndOfProbationary')}</label>
                  <span className="p-d-block">
                    <div className="p-inputgroup calendar-icon-only">
                      <InputMask id={"start_date"}
                                 mask={"9999-99-99"}
                                 placeholder={t('datePlaceholder')}
                                 value={moment.utc(formData.end_of_probationary).local().format('YYYY-MM-DD')}
                                 onChange={(e) => {
                                   if (e.value.indexOf("_") === -1) {
                                     if (e.value === '') {
                                       e.value = null
                                     }
                                     setFormData({
                                       ...formData,
                                       end_of_probationary: moment.utc(e.value).local().format('YYYY-MM-DD')
                                     })
                                   }
                                 }}
                      />
                      <Calendar value={formData.end_of_probationary}
                                locale="hu"
                                dateFormat={'yy-mm-dd'}
                                showIcon
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    end_of_probationary: moment.utc(e.value).local().format('YYYY-MM-DD')
                                  })
                                }}/>
                    </div>
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>


          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'employment' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(EmploymentFormComponent);
